// API Base URL - Always use the URL from environment variables
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.dawaak-andna.com';

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication
  LOGIN: '/api/cms/login',
  LOGOUT: '/api/cms/logout',
  
  // Add other endpoints here as needed
  CATEGORIES: '/api/cms/categories',
  SUBCATEGORIES: '/api/cms/subcategories',
  PRODUCTS: '/api/cms/products',
  SLIDERS: '/api/cms/sliders',
  MESSAGES: '/api/cms/messages',
  SETTINGS: '/api/cms/settings',
} as const;

// Helper function to build full API URL
export const buildApiUrl = (endpoint: string): string => {
  return `${API_BASE_URL}${endpoint}`;
};
